import Vue from "vue";
import Vuex from "vuex";
import auth from "@/auth";
import messages from "@/messages";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    messages,
  },
  strict: process.env.NODE_ENV !== "production",
});
